import axios from "axios";

export default function getCustomField() {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `/account/api/v1/node-custom-fields`
      )
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
